export const GET_COMMISSION_TREND_YEAR_TRADE_DAY = 'GET_COMMISSION_TREND_YEAR_TRADE_DAY';
export const GET_COMMISSION_TREND_YEAR_TRADE_DAY_SUCCESS = 'GET_COMMISSION_TREND_YEAR_TRADE_DAY_SUCCESS';
export const GET_COMMISSION_TREND_YEAR_TRADE_DAY_FAILURE = 'GET_COMMISSION_TREND_YEAR_TRADE_DAY_FAILURE';

